var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUsHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 168,
    viewBox: "0 0 199 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_7640_212318)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 68.4004C31 68.4004 31 68.4004 31 68.4004C31 106.177 61.6237 136.8 99.4 136.8C137.176 136.8 167.8 106.177 167.8 68.4004L31 68.4004Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_7640_212318)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 69,
    r: 69,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 129C133.137 129 160 102.137 160 69C160 35.8629 133.137 9 100 9C66.8629 9 40 35.8629 40 69C40 102.137 66.8629 129 100 129Z",
    fill: "#1752AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.619 103.343C110.906 102.554 116.261 100.705 119.862 97.0979C124.333 92.6193 127.818 85.0254 127.818 78.2334V55.1247C127.818 48.3327 124.333 41.4464 119.862 36.9685C115.391 32.4891 108.515 29 101.733 29H98.3495C91.5679 29 84.6927 32.4891 80.2218 36.9685C75.7502 41.4464 72.2656 48.3327 72.2656 55.1247V78.2334",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4513 78.5981C65.0501 78.1066 60 72.3991 60 65.431C60 58.4617 65.0501 52.7542 71.4513 52.2627V78.5981Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.547 78.5981C134.948 78.1066 139.998 72.3991 139.998 65.431C139.998 58.4617 134.948 52.7542 128.547 52.2627V78.5981Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.004 97.8027C103.09 97.8027 105.593 100.309 105.593 103.401C105.593 106.493 103.09 108.999 100.004 108.999C96.9168 108.999 94.4141 106.493 94.4141 103.401C94.4141 100.309 96.9168 97.8027 100.004 97.8027Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7734 52.9354C79.9665 51.2628 86.8547 45.9943 90.7255 38.8486C95.8019 44.1021 102.916 47.3702 110.793 47.3702C115.79 47.3702 120.481 46.0545 124.539 43.7522",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_7640_212318",
    x: 0,
    y: 37.4004,
    width: 198.801,
    height: 130.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 9.29652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7640_212318"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.321569 0 0 0 0 0.686275 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_7640_212318",
    result: "effect2_dropShadow_7640_212318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7640_212318",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_7640_212318",
    x: 12.407,
    y: -18.593,
    width: 175.186,
    height: 175.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 9.29652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7640_212318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7640_212318",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsHeader);
export default __webpack_public_path__ + "static/media/ContactUsHeader.1cd41bf902afc2b6e162ed1f7e9d94b4.svg";
export { ForwardRef as ReactComponent };